import platform from './platformDetection';
import OKSDK from './oksdk';

let appName = null;
let timeoutId = -1;
const beaconsToSend = [];

function parseParams(query) {
  const params = (query || '').split('&');
  const result = {};
  for (let i = 0, l = params.length; i < l; i++) {
      const param = params[i];
      const pair = param.split('=');
      if (pair.length > 0) {
          result[decodeURIComponent(pair[0])] = decodeURIComponent(
              pair.length > 1 ? pair[1] : ''
          );
      }
  }

  return result;
}

function generateParam(name, value) {
    return value ? name + encodeURIComponent(value) : '';
}

function generateBeaconUrl(operation, param1, param2, param3) {
    return [
        'https://m.ok.ru/dk?st.cmd=clientGenericStat&st.opid=',
        encodeURIComponent(operation),
        generateParam('&st.prm1=', param1),
        generateParam('&st.prm2=', param2),
        generateParam('&st.prm3=', param3),
        '&rnd=',
        String(Math.floor(Math.random() * 9999999))
    ].join('');
}

function generateLoadTimeBeaconUrl(domLoadTime, fullLoadTime) {
    return [
        'https://m.ok.ru/dk?st.cmd=clientStat&st.opid=',
        encodeURIComponent('groupApp-' + appName),
        generateParam('&st.rtime=', fullLoadTime),
        generateParam('&st.dtime=', domLoadTime),
        generateParam('&st.cdn=NONE'),
        '&rnd=',
        String(Math.floor(Math.random() * 9999999))
    ].join('');
}

function sendBeacon(url) {
    beaconsToSend.push(url);
    if (timeoutId === -1) {
        timeoutId = setTimeout(sendBeaconsImmediate, 250);
    }
}

function sendBeaconsImmediate() {
    timeoutId = -1;

    for (let i = 0, l = beaconsToSend.length; i < l; i++) {
        const beaconUrl = beaconsToSend[i];

        if (typeof navigator.sendBeacon === 'function') {
            navigator.sendBeacon(beaconUrl);
        } else {
            new Image().src = beaconUrl;
        }
    }

    beaconsToSend.length = 0;
}

export {parseParams};

export default {
    setup(config) {
        const statCore = this;
        appName = config.appName;
        window.addEventListener('load', () => {
            // Small timeout for performance timers to produce correct values and to avoid any slow downs of the app itself.
            setTimeout(() => {
                const maxClientTime = 20000;
                const performanceTiming = window.performance.timing;
                if (!performanceTiming) {
                    sendBeacon(maxClientTime, maxClientTime);
                    return;
                }

                let fullTime = performanceTiming.loadEventEnd - performanceTiming.navigationStart;

                let domTime =
                    performanceTiming.domContentLoadedEventEnd - performanceTiming.navigationStart;

                // Timeout occurred earlier than the window.onload -- we record 20 seconds (maxClientTime) in such case for both DOMContentLoaded and window.onload.
                if (fullTime < 0) {
                    fullTime = maxClientTime;
                }

                if (domTime < 0) {
                    domTime = maxClientTime;
                }

                sendBeacon(generateLoadTimeBeaconUrl(fullTime, domTime));
                statCore.log('start', platform.name, this.getEntryPointId());
            }, 250);
        });

        window.addEventListener('beforeunload', () => {
            sendBeaconsImmediate();
        });
    },

    getEntryPointId() {
        const query = OKSDK.Util.getRequestParameters();
        const customArgs = parseParams(query.custom_args);
        return customArgs.epId;
    },

    log(param1, param2, param3) {
        if (!appName) {
            throw new Error('No appName specified for stats logging.');
        }

        sendBeacon(generateBeaconUrl('groupApp-' + appName, param1, param2, param3));
    },

    forceLog(param1, param2, param3) {
        let _appName = appName;
        if (!_appName) {
            _appName = 'container';
        }

        sendBeacon(generateBeaconUrl('groupApp-' + _appName, param1, param2, param3));
    }
};
